import { VideoInterface } from 'common/types/entities/VideoInterface'
import StyleWrapper from 'publisher/components/core/StyleWrapper'
import { useDelay } from 'publisher/hooks/useDelay'
import { managementSelectors, useManagement } from 'publisher/store/index'
import React from 'react'
import EmbedPlayer from './EmbedPlayer'
import FilePlayer from './FilePlayer'
import SourcePlayer from './SourcePlayer'
import VideoScreenshotPlaceholderUi from './ui/VideoScreenshotPlaceholderUi'

export interface VideoProps {
  entity: VideoInterface
}

const Video = ({ entity }: VideoProps) => {
  const isVisible = useDelay(entity.delay)
  const isScreenshotMode = useManagement(managementSelectors.isScreenshotMode)

  if (isScreenshotMode) {
    return (
      <VideoScreenshotPlaceholderUi
        margin={entity.margin}
        mobileMargin={entity.mobileMargin}
        border={entity.border}
        mobileBorder={entity.mobileBorder}
        boxShadow={entity.boxShadow}
        mobileBoxShadow={entity.mobileBoxShadow}
      />
    )
  }

  let Player: React.ComponentType<VideoProps>
  if (entity.url) {
    Player = SourcePlayer
  } else if (entity.fileId) {
    Player = FilePlayer
  } else {
    Player = EmbedPlayer
  }

  if (!isVisible) {
    return (
      <StyleWrapper
        mobileMargin={entity.mobileMargin}
        margin={entity.margin}
        appearance={{ desktop: false, mobile: false }}
      />
    )
  }

  return (
    <StyleWrapper
      mobileMargin={entity.mobileMargin}
      margin={entity.margin}
      appearance={entity.appearance}
    >
      <Player entity={entity} />
    </StyleWrapper>
  )
}

export default Video
